import { DocumentReviewValidationRuleType } from "src/app/enums/document-review-validation-rule-type.enum";
import { DocumentReviewValidationStatus } from "src/app/enums/document-review-validation-status.enum";

export class ReviewEntry {
	public reviewSetId: string;
	public docId: string;
	public caseId: string;
	public userId: string;
	public emailFamilyId: string;
	public status: number;
	public reviewOrder: number;
	public emailParentId: string;
	public relationship: 'parent' | 'child' | 'standalone';
	public documentTitle: string;
	public hasBeenReviewed: boolean;
	public validationErrors: DocumentReviewValidationRuleType[];
	public validationStatus: DocumentReviewValidationStatus;
	public validationMessage: string;
}
